import React from "react";
import { Loader } from "../../../common/components/Loader";
import useCriteriaVisibility from "../../../common/forms/useCriteriaVisibility";
import { SelectedChoices } from "../choices/SelectedChoices";
import { quickSearchCriteriaSelectionType } from "./useFetchQuickSearchCriteria";
import { useQuickSearchCriteriaSelectionType } from "./useQuickSearchCriteriaSelectionType";
import { ClearSearch } from "../../components/ClearSearch";
import { criteriaElementsType, notDeletableType } from "../../../common/types/search/search";

interface QuickSearchProps {
	criteria: criteriaElementsType;
	notDeletable?: notDeletableType;
	namespace: string;
	onSearchClick: () => void;
	onClearSearch: () => void;
	loading?: boolean;
}

export function QuickSearch({
	criteria,
	notDeletable,
	onSearchClick,
	onClearSearch,
	namespace,
	loading = false,
}: QuickSearchProps) {
	const allCriteriaVisible = useCriteriaVisibility(criteria);
	const criteriaSelectionType = useQuickSearchCriteriaSelectionType();

	const handleSearchClick = (e) => {
		e.preventDefault();
		onSearchClick();
	};

	let content = (
		<div className="loading">
			<Loader />
		</div>
	);
	let errorMessage;
	const errorMessageText =
		criteriaSelectionType === quickSearchCriteriaSelectionType.CUSTOM
			? 'You changed the "Search By" option, so some criteria are hidden because they do not belong to the current "Search By".'
			: 'Some criteria are hidden because they do not belong to the current "Search By".';

	if (!allCriteriaVisible) {
		errorMessage = (
			<div className="error">
				<p className="error-text">{errorMessageText}</p>
			</div>
		);
	}

	if (!loading) {
		content = (
			<>
				<form aria-labelledby="quickSearchTitle">
					{criteria.map((component, key) => (
						<React.Fragment key={key}>{component}</React.Fragment>
					))}
					<div className="actions-wrapper">
						<ClearSearch
							namespace={namespace}
							onClearSearch={onClearSearch}
						/>
						<button
							className="btn btn--primary"
							type="submit"
							onClick={handleSearchClick}
						>
							Search
						</button>
					</div>
				</form>

				{errorMessage}

				<SelectedChoices
					notDeletable={notDeletable}
					criteria={criteria}
				/>
			</>
		);
	}

	return (
		<div className="quick-search-filters">
			<p className="search-type-title h5" id="quickSearchTitle">
				Quick Search
			</p>
			{content}
		</div>
	);
}
